<div class="row p-t-25">
    <app-card [showHeader]="false" padding="16">
        <app-base-create-tools [service]="serviceInstance" [canCreate]="canCreate" [canEdit]="canEdit" [fieldsConfigService]="fieldsConfigServiceInstance"></app-base-create-tools>
        <ng-content></ng-content>
    </app-card>
</div>
